import { AbstractResource } from "./AbstractResource";

export class GatewaysFiles extends AbstractResource {
    async getById(customerId, fileId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/${fileId}`);
        return data;
    }

    async getByCustomer(customerId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files`);
        return data;
    }

    async share(customerId, fileId, sharedWithIds) {
        const { data } = await this.http.post(`/customers/${customerId}/gateway-files/${fileId}/share`, {
            shared_with_ids: sharedWithIds
        });
        return data;
    }

    async create(customerId, dto) {
        const { data } = await this.http.post(`/customers/${customerId}/gateway-files`, dto);
        return data;
    }

    async update(customerId, fileId, dto) {
        const { data } = await this.http.put(`/customers/${customerId}/gateway-files/${fileId}`, dto);
        return data;
    }

    async remove(customerId, fileId) {
        const { data } = await this.http.delete(`/customers/${customerId}/gateway-files/${fileId}`);
        return data;
    }

    async getInfos(customerId, fileId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/${fileId}/infos`);
        return data;
    }

    async getLastProcessSkipDate(customerId, fileId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/${fileId}/last-process-skip-date`);
        return data;
    }

    async getProcesses(customerId, fileId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/${fileId}/processes`);
        return data;
    }

    async getListings(customerId, fileId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/${fileId}/listings`);
        return data;
    }

    async uploadProcess(customerId, fileId, file) {
        const formData = new FormData();
        formData.append('file', file);
        const { data } = await this.http.post(`/customers/${customerId}/gateway-files/${fileId}/processes/upload`, formData, {
            headers: {
                'Content-Type': `multipart/form-data`,
            }
        });
        return data;
    }

    getProcessDownloadUrl(processId, fileType) {
        return `${this.http.defaults.baseURL}/gateway-process/${processId}?action=download&file-type=${fileType}`
    }

    async restartProcess(processId) {
        const { data } = this.http.get(`/gateway-process/${processId}?action=restart`);
        return data;
    }

    async abort(customerId, fileId) {
        const { data } = await this.http.put(`/customers/${customerId}/gateway-files/${fileId}/abort`);
        return data;
    }

    async syncToOdyssey(gatewayFileId) {
        await this.http.post(`/gateway-files/${gatewayFileId}/synchronize-to-odyssey`);
    }
}
